import { JSX } from "react";

export const Text1 = ({
  children,
}: {
  children: JSX.Element | JSX.Element[] | string;
}) => {
  return <div className="text-hx3 font-bold text-black">{children}</div>;
};

export const Text2 = ({
  children,
}: {
  children: JSX.Element | JSX.Element[] | string;
}) => {
  return <div className="text-hx font-medium text-neutral-400">{children}</div>;
};
export const Text3 = ({
  children,
}: {
  children: JSX.Element | JSX.Element[] | string;
}) => {
  return <div className="text-h2  text-neutral-400 mt-2">{children}</div>;
};
